import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import FooterCopyright from "../../components/footer/FooterCopyright";
import InstagramLogo from "../../assets/instagram";

const FooterOne = ({
                     backgroundColorClass,
                     spaceTopClass,
                     spaceBottomClass,
                   }) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <footer
      className={`footer-area ${backgroundColorClass || ""}`}
      style={{
        // backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/img/footer/footer.jpg'})`
      }}
    >
      <div className="container" style={{ height: "inherit" }}>
        <div
          className="pt-20"
          style={{
            height: "inherit",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div className="row" style={{ justifyContent: "space-evenly" }}>
            <div
              className="col-lg-1 col-md-4 col-sm-4"
              style={{ paddingTop: "3.5rem" }}
            >
              <div className="footer-widget mb-30 ml-50">
                <div className="footer-title">
                  <h3>LINKS UTILES</h3>
                </div>
                <div className="footer-list">
                  <ul>
                    <li className="d-flex flex-column" style={{ width: "15rem" }}>
                      <a href="https://museos.gub.uy/" target="_blank">Museos</a>
                      <a href="https://tienda.santillana.com.uy/?code=paseos" target="_blank">Tienda Santillana</a>
                      <Link to={`${process.env.PUBLIC_URL}/contact`}
                            onClick={() => {
                              if (
                                window.location.pathname === "/success" ||
                                window.location.pathname === "/pending" ||
                                window.location.pathname === "/failure" ||
                                window.location.pathname === "/transfer"
                              ) {
                                localStorage.removeItem(
                                  "redux_localstorage_simple_paymentData"
                                );
                              }
                            }}>
                        Contacto
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-1 col-sm-4 d-flex justify-content-center">
              {/* footer copyright */}
              <FooterCopyright
                footerLogo="/assets/img/logo/logo.svg"
              />
            </div>
            <div
              className="col-lg-1 col-md-6 col-sm-6"
              style={{ paddingTop: "3.5rem" }}
            >
              <div
                className="footer-widget mb-30 ml-75"
                style={{ marginLeft: 0 }}
              >
                <div className="footer-title">
                  <h3>SIGUENOS</h3>
                </div>
                <div className="footer-list">
                  <a
                    href="https://www.instagram.com/paseos_en_familia/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramLogo />
                  </a>
                  
                </div>

              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              flexWrap: "wrap",
              textAlign: 'center'
            }}
          >
            <p style={{ fontSize: 10,  color: '#fff', marginTop: '1.5rem' }}>
              © 2022{" "}
              <a style={{ color: '#fff' }} href="/" rel="noopener noreferrer" target="_blank">
                Paseos en familia
              </a>
              . Todos los derechos reservados. Desarrollado por{" "}
              <a
                style={{ color: '#fff' }}
                href="https://www.lografdesign.com/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Lograf Design
              </a>
            </p>
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line react/button-has-type */}
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <i className="fa fa-angle-double-up" />
      </button>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

FooterOne.defaultProps = {
  backgroundColorClass: "",
  spaceBottomClass: "",
  spaceTopClass: "",
};

export default FooterOne;